import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locale/en';
import he from './locale/he';

i18n.use(initReactI18next).init({
  lng: localStorage.getItem('current_language') ? localStorage.getItem('current_language') : 'en',
  resources: {
    en,
    he,
  },
  fallbackLng: 'en',
  debug: false,
  ns: ['translations'],
  defaultNS: 'translations',
  keySeparator: true,
  interpolation: {
    escapeValue: false,
    formatSeparator: ',',
  },
  react: {
    wait: true,
  },
});

export default i18n;
